import { getProductAttributeValue } from '../../../util'
import { ProductInterface } from '@pylot-data/fwrdschema'
import { ItemCondition } from 'config/seo'
import { PylotFrontendConfig } from 'config'

/**
 * @see https://schema.org/OfferItemCondition
 */
export const getItemCondition = (
    productItem: ProductInterface,
    config: PylotFrontendConfig
): ItemCondition => {
    let itemCondition = getProductAttributeValue(
        productItem,
        'item_condition',
        config
    )
    // If product doesn't have the attribute, or no condition map is provided - item should be new by default
    if (
        itemCondition === undefined ||
        itemCondition === null ||
        !config.seo.product?.itemConditionMap
    ) {
        return ItemCondition.NEW
    }
    itemCondition = String(itemCondition)
    try {
        const conditionMap = JSON.parse(config.seo.product?.itemConditionMap)
        return isValidConditionMap(conditionMap) && conditionMap[itemCondition]
            ? conditionMap[itemCondition]
            : ItemCondition.NEW
    } catch (e) {
        return ItemCondition.NEW
    }
}

const isValidConditionMap = (
    mapObject?: Record<never, never> | null
): mapObject is Record<string, ItemCondition> => {
    if (!mapObject) {
        return false
    }
    let result = true
    const conditionValues = Object.values(ItemCondition)
    Object.values(mapObject).forEach((value: any) => {
        if (!conditionValues.includes(value)) {
            result = false
        }
    })
    return result
}
